import { Drawer } from 'antd'

type InfoDrawerProps = {
  title: string
  visible: boolean
  onClose: () => void
  size?: number
  children: any
  style?: React.CSSProperties
}
const InfoDrawer = ({ title, visible, onClose, size, children, style }: InfoDrawerProps) => {
  return (
    <Drawer title={title} width={size || 500} onClose={onClose} visible={visible} style={style ? style : {}}>
      {children}
    </Drawer>
  )
}

export { InfoDrawer }
